import { environment } from '@environment';
import type { GalleryShareAccessDTO } from './infrastructure/gallery-share-api.service';

/**
 * The absolute share link (`/g/<token>`) the «Поделиться» window hands out — one function, so the
 * settings screen shows the client exactly the address the window copies. The OWNER's verified custom
 * domain wins over the platform origin (server-resolved); an empty `GALLERY_PUBLIC_ORIGIN` means the
 * guest viewer sits on the same domain, and the link still has to be absolute.
 */
export function shareAddressOf(access: Pick<GalleryShareAccessDTO, 'publicUrl' | 'customOrigin'> | null): string | null {
  if (!access?.publicUrl) return null;
  return new URL(
    access.publicUrl,
    access.customOrigin ?? ((environment.GALLERY_PUBLIC_ORIGIN ?? '') || window.location.origin),
  ).toString();
}
